import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';
import { encodeConst } from '../../constants';
import { maModel } from 'src/app/model/pre-qual-data.model';
@Component({
  selector: 'cibc-customer-relationship',
  templateUrl: './cibc-customer-relationship.component.html',
  styleUrls: ['./cibc-customer-relationship.component.less'],
  providers: [FrameworkUtilityComponent]
})
export class CibcCustomerRelationshipComponent implements OnInit {
  currentLang: string;
  coApplicantSelectionObj: any = {};
  displayValidation: boolean = false;
  selectionY: boolean = null;
  selectionYB: boolean = null;
  selectionN: boolean = null;
  borderColorN: boolean = false;
  borderColorY: boolean = false;
  borderColorYB: boolean = false;
  both: boolean = null
  yesRadio: HTMLInputElement;
  noRadio: HTMLInputElement;
  flowType: any;
  currentRoutePath: string;
  cibcCustomerObj: any = {
    existing_cibc_customer: "",
    are_both_cibc_customer: ""
  };
  isCoapplicantApplied: string;
  referralLink: any;
  loader: boolean = false;
  currLangEn = 'en';
  currLangFr = 'fr';
  prequalType = 'P';
  switchType = 'S';
  referralFlow: any;

  constructor(private util: UtilService, private activatedRoute: ActivatedRoute, private router: Router,
    private i18nService: I18nService, private formUtiObj: FrameworkUtilityComponent,
    private storageService: WebStorageService) {
    this.activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });


    this.isCoapplicantApplied = this.util.getSessionStorage().is_coapplicant_applied;

    this.cibcCustomerObj.hide_show = this.isCoapplicantApplied == 'Y' ? 'Yes' : 'No';
    if (this.isCoapplicantApplied == 'Y') {
      this.both = true
    }
    else {
      this.both = false;
    }
    this.activatedRoute.queryParams.subscribe(params => {
      this.flowType = this.util.getFlowType(params);
      this.referralFlow = this.util.getReferral(params);
    })

  }
  ngOnInit(): void {
    this.util.LOADER.subscribe((obj) => {
      this.loader = obj;
      if (!this.loader) {
        this.borderColorY = false;
        this.borderColorN = false;
        this.borderColorYB = false;
        this.selectionY = null;
        this.selectionN = null;
        this.selectionYB = null;
      }
    })
    this.formUtiObj.InitValues();
    window.scroll(0, 0);
    if (this.referralFlow) {
      this.referralLink = window.location.href;
    }
    else {
      this.referralLink = ''
    }
    //To check if term and condition checkbox checked
    if (sessionStorage.getItem("concentagreed")) {
      sessionStorage.removeItem("concentagreed");
    }
    if (!sessionStorage.getItem(CONSTANTS.nameInSessionStorage.TRANSACTION_ID)) {
      this.storageService.set(CONSTANTS.nameInSessionStorage.TRANSACTION_ID, btoa(String(uuidv4())), Scope.session);
    }
    // Get the current lang from route and set it.
    this.activatedRoute.paramMap.subscribe(params => {
      this.i18nService.setCurrenttLang(params.get('lang'));
      this.currentLang = this.i18nService.getCurrentLang();
    });
  }

  ngAfterViewInit() {
    if (!sessionStorage.getItem("sessioncnc")) {
      sessionStorage.removeItem("sidebarTitle");
      document.getElementById("sidebarTitle").focus();
    }
  }
  buttonDisplay(selected) {
    if (this.displayValidation == true) {
      this.displayValidation = false;
    }

    if (selected == 'yes') {
      this.cibcCustomerObj.existing_cibc_customer = "Y"
      this.cibcCustomerObj.are_both_cibc_customer = "N"
      this.borderColorY = true;
      this.borderColorN = false;
      this.borderColorYB = false;
      this.selectionY = true;
      this.selectionN = false;
      this.selectionYB = false;
    }

    if (selected == 'no') {
      this.cibcCustomerObj.existing_cibc_customer = "N"
      this.cibcCustomerObj.are_both_cibc_customer = "N"
      this.selectionY = false;
      this.selectionN = true;
      this.selectionYB = false;
      this.borderColorY = false;
      this.borderColorN = true;
      this.borderColorYB = false;
    }
    if (selected == 'yesBoth') {
      this.cibcCustomerObj.existing_cibc_customer = "Y"
      this.cibcCustomerObj.are_both_cibc_customer = "Y"
      this.selectionYB = true;
      this.selectionN = false;
      this.selectionY = false;
      this.borderColorY = false;
      this.borderColorN = false;
      this.borderColorYB = true;

    }




  }

  onContinue() {
    if (this.borderColorY == false && this.borderColorN == false && this.borderColorYB == false) {
      if (this.flowType?.type == this.switchType) {
        this.util.adobeAnalyticalErrorMsg("existing-customer", "missing", "", null);
      }
      let temp = document.querySelector("#yes") as HTMLInputElement;
      temp.focus();
      this.displayValidation = true;
      return;
    }
    else {
      this.displayValidation = false;
      this.loader = true;
    }

    //set progress percentage in session to check next route

    this.util.getToken().subscribe((responseObj: any) => {
      if (responseObj && responseObj.token) {
        this.util.storeInSession("auth_token", responseObj.token);
        if (this.cibcCustomerObj.existing_cibc_customer == 'Y' || this.cibcCustomerObj.are_both_cibc_customer == 'Y') {
          this.save();

        } else {
          let preQualObj = this.util.getSessionStorage();
          let lang_ref = sessionStorage.getItem("lang_ref")
          if (environment.pilotEnabled == "true") {
            if (sessionStorage.getItem("pilotFlow") != "pilot") {

              if (lang_ref == "en") {
                window.location.href = environment.api.pre_approval_url_en;
              } else {
                window.location.href = environment.api.pre_approval_url_fr;
              }
              return;
            }
          }
          let preQualSession = {
            "request_id": atob(sessionStorage.getItem("transactionid")),
            "lang_pref": sessionStorage.getItem("currLang"),
            "is_coapplicant_applied": this.isCoapplicantApplied,
            "is_existing_bankcustomers": this.cibcCustomerObj.existing_cibc_customer,
            "are_both_applicants_CIBC_customer": this.cibcCustomerObj.are_both_cibc_customer,
            "status": "inprogress",
            "failure_reason": null,
            "failure_code": null,
            "total_gross_income": 0,
            "flow_type": this.flowType?.type,
            "users": [],
            "referralLink": this.referralLink,
            "mmtg_ma_sync": false
          }

          if (!preQualObj.users || preQualObj.users.length != 0) {
            preQualSession.users = preQualObj.users;
          }
          this.util.setSessionStorage(preQualSession);
          this.util.saveJson(preQualSession).subscribe(result => {
            if (this.referralFlow) {
              this.sendMaDetails(result)
            }
            preQualSession.status = result?.status;
            this.util.setSessionStorage(preQualSession);

          }, (err) => {
            this.router.navigate(['../request-callback'], { relativeTo: this.activatedRoute, queryParamsHandling: 'preserve' });
          }
          )
          const path = this.util.determineNextRoute(this.currentRoutePath);
          this.loader = false;
          this.router.navigate(['../personal-information-about-yourself'], { relativeTo: this.activatedRoute, queryParamsHandling: 'preserve' });
        }
      } else {
        this.goToErrorPage();
      }
    }, (error) => {
      this.goToErrorPage();
    });


  }
  save() {
    let preQualObj = this.util.getSessionStorage();
    //check user logged in with mobile or desktop
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    sessionStorage.setItem("olbRedirect", btoa("oblredirected"));
    let channel = isMobile == true ? 'mobi' : 'olb';
    let preQualSession = {
      "request_id": atob(sessionStorage.getItem("transactionid")),
      "lang_pref": sessionStorage.getItem("currLang"),
      "is_coapplicant_applied": this.isCoapplicantApplied,
      "is_existing_bankcustomers": this.cibcCustomerObj.existing_cibc_customer,
      "are_both_applicants_CIBC_customer": this.cibcCustomerObj.are_both_cibc_customer,
      "status": "inprogress",
      "failure_reason": null,
      "failure_code": null,
      "total_gross_income": 0,
      "flow_type": this.flowType?.type,
      "users": null,
      "referralLink": this.referralLink,
      "mmtg_ma_sync": false
    }
    if (!preQualObj.users || preQualObj.users.length != 0) {
      preQualSession.users = preQualObj.users;
    }

    this.util.setSessionStorage(preQualSession);
    this.util.saveJson(preQualSession).subscribe((result: any) => {
      if (this.referralFlow) {
        this.sendMaDetails(result);
      }
      preQualSession.status = result?.status;
      this.util.setSessionStorage(preQualSession);
      this.util.CLOSE_WINDOW_POPUP.next(false);
      if ((environment.env == "dev") || (environment.env == "pte")) {
        sessionStorage.setItem("redTime", String(new Date().getTime()));
        let callbackurl: string
        if (environment.api.enable_callback == "true" && environment.api.authentication == "cah") {
          callbackurl = environment.backend_base_url + "authenticationUtil/cah-auth-response";
          const encodedCallbackurl = encodeURIComponent(callbackurl);
          if (preQualSession.flow_type == this.prequalType) {
            window.location.href = environment.api.cahSignin + "client_id=" + environment.api.clientId + "&redirect_uri=" + encodedCallbackurl + "&state=PQ_" + atob(sessionStorage.getItem("transactionid")) + "&nonce=prequalification_" + atob(sessionStorage.getItem("transactionid")) + "&ui_locales=" + sessionStorage.getItem("currLang") + "-CA" + "&scope=openid&prompt=login&response_type=code";
          }
          else {
            window.location.href = environment.api.cahSignin + "client_id=" + environment.api.clientId + "&redirect_uri=" + encodedCallbackurl + "&state=DS_" + atob(sessionStorage.getItem("transactionid")) + "&nonce=prequalification_" + atob(sessionStorage.getItem("transactionid")) + "&ui_locales=" + sessionStorage.getItem("currLang") + "-CA" + "&scope=openid&prompt=login&response_type=code";
          }
        } else if (environment.api.enable_callback == "true") {
          callbackurl = environment.backend_base_url + "authenticationUtil/auth-response";
          window.location.href = environment.api.olbSignin + "locale=" + sessionStorage.getItem("currLang") + "&transactionId=" + atob(sessionStorage.getItem("transactionid")) + "&channel=" + channel + "&callbackurl=" + callbackurl;
        } else {
          window.location.href = environment.api.olbSignin + "locale=" + sessionStorage.getItem("currLang") + "&transactionId=" + atob(sessionStorage.getItem("transactionid")) + "&channel=" + channel + "&callbackurl=" + callbackurl;
        }
      } else if (environment.env == "local") {
        this.router.navigate(['../signon'], { relativeTo: this.activatedRoute, queryParamsHandling: 'preserve' });
      }
      else {
        sessionStorage.setItem("redTime", String(new Date().getTime()));
        let callbackurl: string
        if (environment.api.enable_callback == "true" && environment.api.authentication == "cah") {
          callbackurl = environment.backend_base_url + "authenticationUtil/cah-auth-response";
          const encodedCallbackurl = encodeURIComponent(callbackurl);
          if (preQualSession.flow_type == this.prequalType) {
            this.loader = false;
            window.location.href = environment.api.cahSignin + "client_id=" + environment.api.clientId + "&redirect_uri=" + encodedCallbackurl + "&state=PQ_" + atob(sessionStorage.getItem("transactionid")) + "&nonce=prequalification_" + atob(sessionStorage.getItem("transactionid")) + "&ui_locales=" + sessionStorage.getItem("currLang") + "-CA" + "&scope=openid&prompt=login&response_type=code";

          }
          else {
            this.loader = false;
            window.location.href = environment.api.cahSignin + "client_id=" + environment.api.clientId + "&redirect_uri=" + encodedCallbackurl + "&state=DS_" + atob(sessionStorage.getItem("transactionid")) + "&nonce=prequalification_" + atob(sessionStorage.getItem("transactionid")) + "&ui_locales=" + sessionStorage.getItem("currLang") + "-CA" + "&scope=openid&prompt=login&response_type=code";
          }
        } else if (environment.api.enable_callback == "true") {
          callbackurl = environment.backend_base_url + "authenticationUtil/auth-response";
          window.location.href = environment.api.olbSignin + "locale=" + sessionStorage.getItem("currLang") + "&transactionId=" + atob(sessionStorage.getItem("transactionid")) + "&channel=" + channel + "&callbackurl=" + callbackurl;
        } else {
          window.location.href = environment.api.olbSignin + "locale=" + sessionStorage.getItem("currLang") + "&transactionId=" + atob(sessionStorage.getItem("transactionid")) + "&channel=" + channel + "&callbackurl=" + callbackurl;
        }

      }
    }, (err) => {
      this.util.saveError(preQualSession, err).subscribe(data => {

      }, (error) => {

      });
      this.goToErrorPage();
    });
  }
  goToErrorPage() {
    this.router.navigate(['../request-callback'], { relativeTo: this.activatedRoute, queryParamsHandling: 'preserve' });
  }

  handleKeyup(event, focused) {
    if (event.code === "Space") {
      if (focused == "yes") {
        this.selectionY = true;
        this.selectionN = false;
      }
      if (focused == "no") {
        this.selectionY = false;
        this.selectionN = true;
      }


      this.buttonDisplay(focused)
    }

    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      this.yesRadio = document.querySelector("#yes") as HTMLInputElement;
      this.noRadio = document.querySelector("#no") as HTMLInputElement;
      if (focused == "yes") { focused = "no" }
      else { focused = "yes" }
      if (focused == "yes") {
        this.selectionY = true;
        this.selectionN = false;
        this.yesRadio.focus();
      }
      if (focused == "no") {
        this.selectionY = false;
        this.selectionN = true;
        this.noRadio.focus();
      }
      this.buttonDisplay(focused)
    }
  }
  sendMaDetails(result) {
    let maObj: maModel = new maModel();
    maObj = result.madvsior;
    this.util.IS_MA_ASSIGNED.next({maModelObj:maObj,setObj:true});
  }
}

